export default __webpack_public_path__ + "static/media/@jaqueestacomendo.1054978c.jpg";